module.exports = __webpack_public_path__ + "static/citzbooking_about2-ba193482c2bd5883cd37f06a77b69794.png";